import { useState as _useState$ } from "react";
import { renderReactScope as _renderReactScope$ } from "million/react";
import { block as _block$ } from "million/react";
import React, { useState, useRef, useEffect } from "react";
import { IoIosSend } from "react-icons/io";
import { GrStatusGood } from "react-icons/gr";
import { BiErrorAlt } from "react-icons/bi";
import { SlLocationPin } from "react-icons/sl";
import { MdMailOutline } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { BiPhone } from "react-icons/bi";
import { motion } from "framer-motion";
const M$2 = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const formRef = useRef(null);
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  const scrollToSection = sectionId => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  useEffect(() => {
    if (success !== null) {
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
        setSuccess(null);
      }, 6000);
    }
  }, [success]);
  const handleLinkedinClick = () => {
    window.open("https://www.linkedin.com/company/vitrumsoft/about/?viewAsMember=true", "_blank");
  };
  const handleInstagramClick = () => {
    window.open("https://www.instagram.com/vitrumsoft/", "_blank");
  };
  const handleWhatsAppClick = () => {
    const whatsappUrl = "https://wa.me/3471331775?text=Hola%20me%20gustaría%20contactarme%20para...";
    window.open(whatsappUrl, "_blank");
  };
  const sendEmail = async e => {
    e.preventDefault();
    const form = formRef.current;
    const data = new FormData(form);
    if (!data.get("name") || !data.get("email") || !data.get("message") || !data.get("celular")) {
      setSuccess(false);
      return;
    }
    setLoading(true);
    try {
      await emailjs.send("service_m916muo", "template_wqf000e", {
        name: data.get("name"),
        title: "Consulta desde la web",
        email: data.get("email"),
        message: data.get("message"),
        celular: data.get("celular")
      }, "KzU1tdIxQrp31ztl4");
      setSuccess(true);
      form.reset();
    } catch (error) {
      console.error("Error detallado:", {
        status: error.status,
        text: error.text,
        detalles: error.details
      });
      setSuccess(false);
    }
    setLoading(false);
  };
  const contactInfo = [{
    icon: SlLocationPin,
    text: "Rosario, Santa Fe, Argentina",
    action: null
  }, {
    icon: MdMailOutline,
    text: "info@vitrumsoft.com",
    action: () => window.location.href = "mailto:info@vitrumsoft.com"
  }, {
    icon: BiPhone,
    text: "+54 3471 331775",
    action: () => window.location.href = "tel:+543471331775"
  }];
  const socialLinks = [{
    icon: MdMailOutline,
    action: () => window.location.href = "mailto:info@vitrumsoft.com",
    label: "Email"
  }, {
    icon: FaWhatsapp,
    action: handleWhatsAppClick,
    label: "WhatsApp"
  }, {
    icon: FaLinkedin,
    action: handleLinkedinClick,
    label: "LinkedIn"
  }, {
    icon: FaInstagram,
    action: handleInstagramClick,
    label: "Instagram"
  }];
  const _portal = _useState$(() => ({
      $: new Array(1)
    }))[0],
    _ = _renderReactScope$(<div ref={sectionRef} className="relative bg-gradient-to-b from-[#0e0f11] via-[#0a0b0d] to-[#0e0f11] pt-32 pb-40 overflow-hidden" id="contacto">
      {/* Línea decorativa superior */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#bdff57]/30 to-transparent" />
      {/* Elementos decorativos */}
      <div className="absolute top-0 right-1/4 w-96 h-96 bg-[#bdff57]/5 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-1/4 w-80 h-80 bg-[#bdff57]/3 rounded-full blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.8,
          ease: "easeOut"
        }} className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 mb-6 text-sm font-medium text-[#bdff57] border border-[#bdff57]/30 rounded-full bg-[#bdff57]/5">
            Hablemos
          </span>
          <h2 className="text-4xl sm:text-6xl lg:text-7xl font-normal tracking-tight text-white">
            <span className="text-[#bdff57]">Contanos</span> tu idea
          </h2>
          <p className="mt-6 text-lg text-gray-400 max-w-2xl mx-auto">
            Nos encantaría poder comunicarnos contigo y ayudarte a hacer realidad tu proyecto
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Información de contacto */}
          <motion.div initial={{
            opacity: 0,
            x: -30
          }} animate={isVisible ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.2
          }}>
            <div className="space-y-8">
              {/* Info items */}
              {contactInfo.map((item, index) => <div key={index} className={`flex items-center gap-4 group ${item.action ? 'cursor-pointer' : ''}`} onClick={item.action}>
                  <div className="w-14 h-14 rounded-xl bg-[#bdff57]/10 flex items-center justify-center">
                    <item.icon className="w-6 h-6 text-[#bdff57]" />
                  </div>
                  <span className={"text-lg text-gray-300"}>
                    {item.text}
                  </span>
                </div>)}
            </div>

            {/* Separador */}
            <div className="my-10 h-px bg-gradient-to-r from-white/10 via-white/5 to-transparent" />

            {/* Redes sociales */}
            <div>
              <p className="text-sm text-gray-500 uppercase tracking-wider mb-6">
                Seguinos en redes
              </p>
              <div className="flex gap-4">
                {socialLinks.map((social, index) => <button key={index} onClick={social.action} className="w-12 h-12 rounded-xl bg-white/5 hover:bg-[#bdff57]/20 flex items-center justify-center transition-all duration-300 group border border-white/5 hover:border-[#bdff57]/30" aria-label={social.label}>
                    <social.icon className="w-5 h-5 text-gray-400 group-hover:text-[#bdff57] transition-colors" />
                  </button>)}
              </div>
            </div>
          </motion.div>

          {/* Formulario */}
          <motion.div initial={{
            opacity: 0,
            x: 30
          }} animate={isVisible ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3
          }}>
            <form ref={formRef} onSubmit={sendEmail} className="p-8 rounded-2xl bg-gradient-to-br from-[#1a1b1e] to-[#141517] border border-white/5">
              <div className="space-y-6">
                <div>
                  <label className="text-white text-sm font-medium block mb-2">
                    Nombre y apellido
                  </label>
                  <input type="text" name="name" placeholder="Tu nombre completo" className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none" required />
                </div>

                <div>
                  <label className="text-white text-sm font-medium block mb-2">
                    Email
                  </label>
                  <input type="email" name="email" placeholder="tu@email.com" className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none" required />
                </div>

                <div>
                  <label className="text-white text-sm font-medium block mb-2">
                    Celular
                  </label>
                  <input type="tel" name="celular" placeholder="Tu número de teléfono" className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none" required />
                </div>

                <div>
                  <label className="text-white text-sm font-medium block mb-2">
                    Mensaje
                  </label>
                  <textarea name="message" placeholder="Contanos sobre tu proyecto..." rows={4} className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-500 focus:outline-none resize-none" required />
                </div>

                <button type="submit" disabled={loading} className="w-full py-4 rounded-xl bg-[#bdff57] text-black font-semibold hover:bg-[#a8e64c] transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
                  {loading ? "Enviando..." : <>
                      Enviar mensaje
                      <IoIosSend className="w-5 h-5" />
                    </>}
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      </div>

      {/* Botón WhatsApp flotante */}
      <div className="fixed bottom-6 right-6 z-50 group">
        <button onClick={handleWhatsAppClick} aria-label="WhatsApp" className="w-11 h-11 sm:w-14 sm:h-14 rounded-full bg-green-500 text-white flex items-center justify-center shadow-lg hover:bg-green-600 transition-all duration-300">
          <FaWhatsapp className="w-7 h-7" />
        </button>

        {/* Tooltip */}
        <div className="
          absolute right-16 top-1/2 -translate-y-1/2 translate-x-2
          bg-[#1a1b1e] text-white text-sm
          px-3 py-2 rounded-lg
          opacity-0 group-hover:opacity-100
          group-hover:translate-x-0
          transition-all duration-300
          whitespace-nowrap
          pointer-events-none
          border border-white/10
        ">
          Chateá con nosotros
        </div>
      </div>

      {/* Alert de estado */}
      {showAlert && <motion.div initial={{
        opacity: 0,
        x: 100
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: 100
      }} className={`fixed top-24 right-4 px-6 py-4 rounded-xl font-medium text-white shadow-2xl z-50 flex items-center gap-3 ${success ? "bg-green-500" : "bg-red-500"}`}>
          {success ? <GrStatusGood className="text-xl" /> : <BiErrorAlt className="text-xl" />}
          {success ? "Mensaje enviado correctamente" : "Error al enviar el mensaje"}
        </motion.div>}
    </div>, false, _portal.$, 0, false);
  return <><P$ _={_} />{_portal.$.map(p => p.portal)}</>;
};
const P$ = /*million:transform*/_block$(({
  _
}) => {
  return _;
}, {
  svg: false,
  shouldUpdate: (a, b) => a?._ !== b?._
});
const Contact = M$2;
export default Contact;